import React, { useEffect } from 'react'

import { Button } from '@it-incubator/ui-kit'
import { Link, useNavigate, useParams } from 'react-router-dom'

import { fetchTasks } from './exam-actions'
import style from './Exam.module.css'
import { ExamBox } from './ExamBox/ExamBox'
import { selectExamStatus } from './selector'

import { BackLink, Loader } from 'common/components'
import { useAppDispatch, useAppSelector, useDocumentTitle, useKeyDown } from 'common/hooks'
import { Paths } from 'common/routes'
import { selectTitle } from 'features/dashboard'

export const Exam = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const testId = useParams().id as string

  const title = useAppSelector(state => selectTitle(state, testId))
  const status = useAppSelector(selectExamStatus)

  useEffect(() => {
    dispatch(fetchTasks(testId))
  }, [])

  useDocumentTitle(title)
  useKeyDown(() => navigate(Paths.Info), 'Escape')

  return (
    <div className={style.box}>
      <Button as={Link} to={Paths.Info} variant="back">
        Назад к выбору теста
      </Button>
      {status === 'loading' ? <Loader /> : <ExamBox testId={testId} />}
    </div>
  )
}
